import styled from 'styled-components'
import Chevron from '../static/chevron.png'

/* Use like that 👇
<Label>
  <span>Label</span>
  <input type='text'/>
</Label>
*/

export const Label = styled.label`
  display: block;
  position: relative;
  margin: ${(props) => (props.$noMargin ? '0' : props.$styles.margin)};
  width: ${(props) => props.$styles.width || '100%'};
  max-width: ${(props) => {
    if (props.$size === 'small') return '269px'
    if (props.$size === 'medium') return '407px'
    if (props.$size === 'large') return '582px'
    return '345px' // valeur par défaut pour la rétrocompatibilité
  }};

  > span {
    margin-bottom: 1rem;
    display: block;
    font-weight: 600;
  }

  input,
  select {
    display: block;
    width: 100%;
    box-sizing: border-box;
    outline: none;
    border: none;
    border-bottom: 1px solid #c4c4c4;
    padding: 8px 0 8px 2px;
    font-size: 1rem;
    line-height: 1.25rem;
    font-family: 'Barlow';
    background-color: transparent;
    color: #333333;
  }

  select {
    // height: 3rem;
    cursor: pointer;
    padding: 8px 0 8px 2px;
    -webkit-appearance: none;
    background: url('${Chevron}');
    background-repeat: no-repeat;
    background-size: 1rem;
    background-position-y: calc(100% - 1rem);
    background-position-x: calc(100% - 0rem);
  }

  select:disabled {
    cursor: not-allowed;
    border-bottom: 1px solid #d8d8d8;
    color: #d8d8d8;
  }

  input::placeholder {
    color: ${(props) => (props.$focus ? 'transparent' : '#dbd9d9')};
  }

  input.slot {
    font-weight: 600;
    border-bottom: 1px solid #c4c4c4;
    padding: 8px 0 8px 2px;
  }

  input.slot::placeholder {
    font-weight: 400;
  }

  select.slot {
    height: auto;
    font-weight: 600;
    border-bottom: 1px solid #c4c4c4;
    padding: 8px 0 8px 2px;
    margin-left: 0;
    background-position-y: center;
  }

  input.error,
  select.error {
    border-bottom: 1px solid rgba(243, 146, 116, 1);
  }

  > div.error {
    color: rgba(243, 146, 116, 1);
    position: ${(props) => (props.$noMargin ? 'relative' : 'absolute')};
    margin-top: 4px;
    font-size: 0.8rem;
    width: max-content;
  }

  // Phone number
  > div.PhoneInput {
    max-width: 345px;
    width: auto;
  }

  > div.PhoneInput.error {
    border-bottom: 1px solid rgba(243, 146, 116, 1);
    position: relative;

    input {
      border: none;
    }
  }

  input:disabled {
    cursor: not-allowed;
    border-bottom: 1px solid #d8d8d8;
    color: #d8d8d8;
    -webkit-text-fill-color: #d8d8d8;
  }

  input:disabled::placeholder {
    color: transparent;
  }

  textarea {
    display: block;
    width: 100%;
    box-sizing: border-box;
    outline: none;
    border: none;
    border-bottom: 1px solid #c4c4c4;
    padding: 8px 0 8px 2px;
    font-size: 1rem;
    line-height: 1.25rem;
    font-family: 'Barlow';
    background-color: transparent;
    color: #333333;
    width: 175%;
    &::placeholder {
      color: #d8d8d8;
    }
  }

  // Autocomplete component
  .autocomplete-dropdown-container {
    display: block;
    position: absolute;
    width: calc(100% - 1.6rem);
    padding: ${(props) => (props.$loaded === 'true' ? '0.8rem' : '0')};
    max-width: 345px;
    box-shadow: 1px 1px 4px rgb(0 0 0 / 25%);
    border-radius: 3px;
    background-color: white;
    z-index: 10;
  }
`

Label.defaultProps = {
  $styles: {
    width: '100%',
    margin: '0 0 2rem 0'
  }
}
